import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';

/** Keep transaction owners mounted until their operation settles. */
export function usePendingNavigation(pending: boolean) {
  const blocker = useBlocker(() => pending);
  useEffect(() => {
    if (!pending && blocker.state === 'blocked') blocker.proceed();
  }, [pending, blocker]);
  useEffect(() => {
    const warn = (event: BeforeUnloadEvent) => {
      if (pending) { event.preventDefault(); event.returnValue = ''; }
    };
    window.addEventListener('beforeunload', warn);
    return () => window.removeEventListener('beforeunload', warn);
  }, [pending]);
}
